<template>
	<main class="login">
		<section class="padded-md">
			<div class="top">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50" height="50"><path d="M25 3c-6.637 0-12 5.363-12 12v5H9c-1.645 0-3 1.355-3 3v24c0 1.645 1.355 3 3 3h32c1.645 0 3-1.355 3-3V23c0-1.645-1.355-3-3-3h-4v-5c0-6.637-5.363-12-12-12Zm0 2c5.566 0 10 4.434 10 10v5H15v-5c0-5.566 4.434-10 10-10ZM9 22h32c.555 0 1 .445 1 1v24c0 .555-.445 1-1 1H9c-.555 0-1-.445-1-1V23c0-.555.445-1 1-1Zm16 8c-1.7 0-3 1.3-3 3 0 .898.398 1.688 1 2.188V38c0 1.102.898 2 2 2 1.102 0 2-.898 2-2v-2.813c.602-.5 1-1.289 1-2.187 0-1.7-1.3-3-3-3Z"/></svg>
				<h3>Guest Area</h3>
				<p class="body-lg">Please enter the password located at the bottom of the details card included with your invitation.</p>
			</div>

			<form @submit.prevent="verifyPassword">
				<input type="password" v-model="password" autocomplete="off"/>
				<input type="submit" class="inline"/>
			</form>

			<div class="error-message">
        <p class="body-sm" v-if="this.displayErrorMessage">The password you entered is incorrect. Please try again.</p>
      </div>
		</section>
	</main>
</template>

<script>
	export default {
		data() {
			return {
				password: null,
				displayErrorMessage: false
			}
		},
		computed: {
			meatloaf() {
				return this.$store.getters.meatloaf
			}
		},
		beforeCreate() {
			if(document.cookie.split('=')[1] === "true") {
				this.$router.push('/')
			} else {
				return
			}
		},
		methods: {
			verifyPassword() {
				const pw = this.password.toLowerCase()

				if(pw === this.meatloaf) {
					let redirectPath = this.$route.query.redirect === undefined ? '/home' : this.$route.query.redirect

					document.cookie = "ZdH1Z1CQN0=true;expires=Fri, 07 Feb 2025 00:00:00 UTC"
					window.location.href = redirectPath
				} else {
					this.displayErrorMessage = true
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.padded-md {
		align-items: center;
		display: flex;
		flex-direction: column;
		height: 100%;
		justify-content: center;
		min-height: 70vh;

		.top {
			align-items: center;
			display: flex;
			flex-direction: column;
			justify-content: center;
		}

		h3 {
			margin: $space-3;
		}

		p {
			margin: 0;
			max-width: 400px;
			text-align: center;
		}

		form {
			margin-top: $space-2;
		}

		.error-message {
			margin-top: $space-2;
			min-height: 15px;
		}
	}
</style>